import { useRef, useEffect } from 'react';

export function useImageHeight(offset = 0) {
  const ref = useRef();

  useEffect(() => {
    let timeout = null;

    function onResize() {
      clearTimeout(timeout);
      ref.current.style.width = '';

      timeout = setTimeout(() => {
        const rect = ref.current.getBoundingClientRect();
        const diff = window.innerHeight - rect.bottom - offset;

        if (diff < 0) {
          const newWidth = (rect.width / rect.height) * (rect.height + diff);
          ref.current.style.width = `${newWidth}px`;
        }
      }, 60);
    }

    window.addEventListener('resize', onResize);
    onResize();

    return () => {
      clearTimeout(timeout);
      window.removeEventListener('resize', onResize);
    };
  }, [offset]);

  return ref;
}

export default {
  useImageHeight,
};
